// Webpack Imports
import * as bootstrap from 'bootstrap';

const breakpoints = Object.freeze({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});

class Idezen {

    /**
     * Header information
     * @type {{switchEnabled: boolean, element: HTMLElement|undefined, height: number, isSwitched: boolean}}
     */
    header = { element: undefined, height:0, switchEnabled: false, isSwitched: false };

    /**
     * Banner information
     * @type {{element: HTMLElement | undefined}}
     */
    banner = { element: undefined};

    /**
     *  Page resize callback
     * @type {Array<Function>}
     */
    resizeObservers = [];

    /**
     *
     * @type {Array<(previous: boolean, current: boolean) => void>}
     */
    switchActivationObservers = [];


     constructor() {
        this.watchHeadingForHeaderSwitch = this.watchHeadingForHeaderSwitch.bind(this);
        this.resize = this.resize.bind(this);

        /**
         * Enable switch detection
         */
        this.detectHeaderSwitchActivation = this.detectHeaderSwitchActivation.bind(this);
        this.resizeObservers.push(this.detectHeaderSwitchActivation);
        this.detectHeaderSwitchActivation();

        /**
         * Initialize elements
         */
        this.initHeader();
        this.initBanner();

        /**
         * Run Switch
         */
        this.switch(this.headerShouldBeSwitched());

        /**
         * Watch resize
         */
        window.addEventListener('resize', this.resize);
    }

    /**
     *  Call each callable set in resizeObservers array
     */
    resize() {
        this.resizeObservers.forEach(callback => callback());
    }

    /**
     * Set header element, header height, and add resize listener
     */
    initHeader() {

        this.header.element = document.querySelector('.branding-header');

        if (!this.header.element) {
            return;
        }

        // Change header value on window resize
        this.resizeObservers.push(() => {
            const height = this.header.element.getBoundingClientRect().height;
            if (this.header.height !== height) {
                this.setHeaderHeight(height);
            }
        });

        this.setHeaderHeight(this.header.element.getBoundingClientRect().height);
    }

    /**
     * Set banner and add scroll listener
     */
    initBanner() {
        this.banner.element = document.querySelector('.region-banner');

        if (this.banner.element) {

            new IntersectionObserver(([e]) => {
                    if (e.isIntersecting) {
                        window.addEventListener('scroll', this.watchHeadingForHeaderSwitch);
                    } else {
                        window.removeEventListener('scroll', this.watchHeadingForHeaderSwitch);
                    }
                },
                {threshold: [0]}
            ).observe(this.banner.element);


        }

    }

    /**
     * Set header height and update css variable on body
     * @param {number} height
     */
    setHeaderHeight(height) {
        this.header.height = height;
        document.body.style.setProperty('--wp--custom--header--height', `${height}px`);
    }


    /**
     * Determine if header is over banner
     * @return {boolean}
     */
     headerShouldBeSwitched() {
        if (!this.banner.element || !this.header.element) {
            return false;
        }

        return this.banner.element.getBoundingClientRect().bottom <= (this.header.height / 2);
    }

    /**
     * Switch header if necessary
     */
    watchHeadingForHeaderSwitch() {
        if (!this.banner.element || !this.header.element) {
            return;
        }

        this.switch(this.headerShouldBeSwitched());
    }

    /**
     * Toggle `switched` class on header element
     * @param {boolean} isSwitched
     */
    switch(isSwitched) {
        if (this.header.element) {
            this.header.element.classList.toggle('switched', isSwitched);
            this.header.isSwitched = isSwitched;
        }
    }

    /**
     * Disable on enable header switch if window size is greater than value set in `breakpoints.xl`.
     * @see breakpoints.xl
     */
    detectHeaderSwitchActivation() {
        const previous = this.header.switchEnabled;
        const enabled = window.matchMedia(`(min-width:${breakpoints.xl}px)`).matches;
        this.header.switchEnabled = enabled;

        if (previous !== enabled) {
            this.switchActivationObservers.forEach(observer => observer(this.header.switchEnabled, enabled));
        }

    }
}



(function () {
    'use strict';

    // Focus input if Search form is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            const search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    
    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });


    new Idezen();
})();